// extracted by mini-css-extract-plugin
export default {"separator":"Line__separator--3yh","line":"Line__line--3NW"};